const SettingsTypes = {
  SET_USER_THEMES: 'SETTINGS_TYPES.SET_USER_THEMES',
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default SettingsTypes;
